import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CustomerIntegrationsTable} from "./components/CustomerIntegrationsTable";
import React from "react";

export const CustomerIntegrationsPage = () => {
    return (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <CustomerIntegrationsTable />
        </CustomerFluidSubPageLayout>
    );
};
